<template>
  <b-container id="new-company">
    <h1 v-translate>New Company</h1>
    <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountDown=0" @dismiss-count-down="countDownChanged">
      <h5 v-translate>Company was created!</h5>
    </b-alert>
    <b-row>
      <b-col class="p-0">
        <b-form @submit.prevent="createCompany">
          <b-row>
            <b-col>
              <b-card class="company-info">
                <b-row>
                  <b-col>
                    <b-form-group :label="$gettext('Brand/Commercial name')" label-for="brand-name">
                      <b-form-input id="brand-name" v-model="company.name" :disabled="!company.country_iso_code" trim required></b-form-input>
                    </b-form-group>
                    <b-form-group v-if="accountingCatalogs.filter(x => x.catalog === 'document_types').length > 0" :label="$gettext('Document Type')" label-for="company-tin-type">
                      <b-form-select id="company-tin-type" v-model="company.tin_type" :options="accountingCatalogs.filter(x => x.catalog === 'document_types').map(x => { return {text: x.name, value: x.id}})" class="form-control" required>
                        <template #first>
                          <option :value="null" v-translate>Document Type</option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                    <b-form-group :description="$gettext('Company\'s fiscal ID')" :label="accountingCatalogs.findIndex(x => x.catalog === 'document_types' && x.id === company.tin_type) !== -1 ? accountingCatalogs.find(x => x.catalog === 'document_types' && x.id === company.tin_type).name : $gettext('Document Number')" label-for="tin">
                      <b-form-input id="tin" v-model="company.tin" :disabled="!company.country_iso_code" trim></b-form-input>
                    </b-form-group>
                    <b-form-group :description="$gettext('Company\'s fiscal country')" :label="$gettext('Country')" label-for="country" v-if="isInternational">
                      <b-form-select v-model="company.country_iso_code" :options="countriesSelect" class="form-control">
                        <template slot="first">
                          <option :value="null" v-translate>Select a country</option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                    <b-form-group id="business-name" :label="$gettext('Business/Fiscal\'s name')" label-for="name">
                      <b-form-input id="name" v-model="company.business_name" :disabled="!company.country_iso_code" trim></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group v-if="accountingCatalogs.filter(x => x.catalog === 'customer_types').length > 0" :label="$gettext('Client Type')" label-for="company-entity-type">
                      <b-form-select id="company-entity-type" v-model="company.entity_type" :options="accountingCatalogs.filter(x => x.catalog === 'customer_types').map(x => { return {text: x.name, value: x.id}})" class="form-control" required>
                        <template #first>
                          <option :value="null" v-translate>Client Type</option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                    <b-form-group v-if="accountingCatalogs.filter(x => x.catalog === 'tax_conditions').length > 0" :label="$gettext('Contributor Type')" label-for="company-contributor-type">
                      <b-form-select id="company-contributor-type" v-model="company.contributor_type" :options="accountingCatalogs.filter(x => x.catalog === 'tax_conditions').map(x => { return {text: x.name, value: x.id}})" class="form-control" required>
                        <template #first>
                          <option :value="null" v-translate>Contributor Type</option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <h3 v-translate>Industries</h3>
                    <div class="form-group">
                      <b-form-radio-group v-model="company.industries" required>
                        <b-form-radio class="w-50 mr-0" v-for="(i, index) in industries.map(x => {return {text: x.description, value: x.id}})" :value="i.value" :key="index">{{i.text === 'Other' ? $pgettext('fem', 'Other') : i.text}}</b-form-radio>
                      </b-form-radio-group>
                    </div>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-card>
                <h2 v-translate>Company Contacts</h2>
                <hr>
                <b-row>
                  <b-col>
                    <h3 v-translate>Commercial</h3>
                    <b-form-group :description="$gettext('Company\'s contact person')" :label="$gettext('Contact full name')" label-for="contact-name">
                      <b-form-input id="contact-name" v-model="company.contact_name" trim required></b-form-input>
                    </b-form-group>
                    <b-form-group :description="$gettext('Company\'s email')" :label="$gettext('E-mail')" label-for="contact-email">
                      <b-form-input id="contact-email" type="email" v-model="company.email" trim required></b-form-input>
                    </b-form-group>
                    <b-form-group :description="$gettext('Company\'s phone (Intl. format)')" :label="$gettext('Phone')" label-for="contact-phone">
                      <cleave id="contact-phone" ref="phoneControl" :options="{ phone: true, phoneRegionCode: (this.company.country_iso_code ? this.company.country_iso_code.toLowerCase() : 'ar') }" class="form-control" v-model="company.phone"></cleave>
                      <b-button size="sm" v-if="company.phone" style="padding: 0.1rem 1rem;" class="mt-1" variant="secondary" :href="$options.filters.whatsappize(company.phone)">
                        WhatsApp
                      </b-button>
                    </b-form-group>
                    <b-form-group :description="$gettext('Company\'s address')" :label="$gettext('Fiscal address')" label-for="contact-address">
                      <b-form-textarea id="contact-address" v-model="company.address" rows="3" max-rows="6" required></b-form-textarea>
                    </b-form-group>
                    <b-form-group v-if="accountingCatalogs.filter(x => x.catalog === 'states').length > 0" :label="$gettext('Province/State')" label-for="company-address-state">
                      <b-form-select id="company-address-state" v-model="company.address_state" :options="accountingCatalogs.filter(x => x.catalog === 'states').map(x => { return {text: x.name, value: x.id}})" class="form-control" required>
                        <template #first>
                          <option :value="null" v-translate>Province/State</option>
                        </template>
                      </b-form-select>
                    </b-form-group>

                    <h3 class="mt-4" v-translate>Technical <small class="text-muted">(optional)</small></h3>
                    <p><small v-translate>Note: If there is not a Technical Contact all technical communications (webhooks/API applications/technical news/etc.) will be sent to the Commercial Contact.</small></p>
                    <b-form-group :description="$gettext('Technical Person\'s Name')" :label="$gettext('Name')" label-for="technical-contact-name">
                      <b-form-input id="technical-contact-name" type="text" v-model="company.technical_contact_name" trim></b-form-input>
                    </b-form-group>
                    <b-form-group :description="$gettext('Technical Person\'s E-mail')" :label="$gettext('E-mail')" label-for="technical-contact-email">
                      <b-form-input id="technical-contact-email" type="email" v-model="company.technical_contact_email" trim></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <h3 v-translate>Billing</h3>
                    <b-form-group :description="$gettext('Company\'s contact name')" :label="$gettext('Contact name')" label-for="billing-name" v-if="!isSelfService">
                      <b-form-input id="billing-name" v-model="company.billing_details.name" trim required></b-form-input>
                    </b-form-group>
                    <b-form-group :description="$gettext('Company\'s contact last name')" :label="$gettext('Contact last name')" label-for="contact-last-name" v-if="!isSelfService">
                      <b-form-input id="contact-last-name" v-model="company.billing_details.last_name" trim required></b-form-input>
                    </b-form-group>
                    <b-form-group :description="$gettext('Company\'s phone (Intl. format)')" :label="$gettext('Phone')" label-for="billing-phone" v-if="!isSelfService">
                      <cleave id="billing-phone" ref="phoneControl" :options="{ phone: true, phoneRegionCode: this.$cookies.get('country').toLowerCase() }" class="form-control" v-model="company.billing_details.phone" v-if="company.billing_details"></cleave>
                      <b-button size="sm" v-if="company.billing_details && company.billing_details.phone" style="padding: 0.1rem 1rem;" class="mt-1" variant="secondary" :href="$options.filters.whatsappize(company.billing_details.phone)">
                        WhatsApp
                      </b-button>
                    </b-form-group>
                    <label class="d-block" v-if="!isSelfService" v-translate>Billing emails</label>
                    <div class="form-group" v-for="(item, index) in company.billing_details.emails" :key="index" v-if="!isSelfService">
                      <b-input-group>
                        <b-input type="email" :placeholder="$gettext('E-mail')" class="form-control" :id="'company__billing__email' + index" v-model="company.billing_details.emails[index]" required />
                        <b-input-group-append>
                          <b-button size="sm" variant="danger" @click="removeBillingDetailsEmail(index)" style="padding-top: initial; padding-bottom: initial;">
                            <strong>✕</strong>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </div>
                    <form @submit.prevent="addBillingDetailsEmail" v-if=" !isSelfService && company.billing_details.emails.length < 5">
                      <b-input-group>
                        <b-input type="email" :placeholder="$gettext('E-mail')" class="form-control" id="company__billing__email" v-model="newBillingDetailsEmail" :required="company.billing_details.emails.length === 0" />
                        <b-input-group-append>
                          <b-button size="sm" variant="success" :disabled="newBillingDetailsEmail === ''" type="submit" style="padding-top: initial; padding-bottom: initial;">
                            <strong>＋</strong>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                      <b-form-text v-translate>Up to 5 e-mail addresses that will receive our invoices.</b-form-text>
                    </form>

                    <h3 class="mt-4" v-translate>Operations <small class="text-muted">(optional)</small></h3>
                    <p><small v-translate>Note: If there is not a Operations Contact all communications about operations (pending pickups/etc.) will be sent to the Commercial Contact.</small></p>
                    <b-form-group :description="$gettext('Operations Person\'s Name')" :label="$gettext('Name')" label-for="operations-contact-name">
                      <b-form-input id="operations-contact-name" type="text" v-model="company.operations_contact_name" trim></b-form-input>
                    </b-form-group>
                    <b-form-group :description="$gettext('Operations Person\'s E-mail')" :label="$gettext('E-mail')" label-for="operations-contact-email">
                      <b-form-input id="operations-contact-email" type="email" v-model="company.operations_contact_email" trim></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-card v-if="!user.id">
                <h3 v-translate>Company Admin User</h3>
                <b-form-group :label="$gettext('User full name')" label-for="user-name">
                  <b-form-input id="user-name" v-model="user.name" trim required></b-form-input>
                </b-form-group>
                <b-form-group :label="$gettext('E-mail')" label-for="user-email">
                  <b-form-input id="user-email" type="email" v-model="user.email" trim required></b-form-input>
                </b-form-group>
                <b-form-group :label="$gettext('Password')" label-for="user-password">
                  <password ref="pwd_check" :min="passwordMinLength" :placeholder="$gettext('Password')" v-model="user.password" input-class="form-control" @score="newPasswordScore = $event" :min-score="passwordMinScore" />
                  <b-form-text id="inputLiveHelp" v-translate="{minLength: passwordMinLength}">%{minLength} characters minimum, must contain upper and lower case letters, numbers and symbols</b-form-text>
                </b-form-group>
              </b-card>
              <b-card v-else>
                <h3 v-translate>Company Admin User</h3>
                <p v-translate="{userName: user.name, userEmail: user.email}">Company Admin User <strong>%{userName} (%{userEmail})</strong> already created. Please, fix errors or complete Company information and re-send to complete creation.</p>
              </b-card>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button variant="secondary" type="submit" size="lg" :disabled="!formCompleted" v-translate>Create Company</b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Cleave from 'vue-cleave'
import Password from '@/components/Password'

export default {
  components: {
    Password,
    Cleave
  },
  data() {
    return {
      tabIndex: 0,
      company: {
        country_iso_code: null,
        billing_details: {
          emails: []
        },
        industries: null
      },
      user: {
        name: '',
        email: '',
        password: '',
        terms: true
      },
      passwordMinLength: 12,
      passwordMinScore: 100,
      newPasswordScore: 0,
      isSelfService: false,
      dismissSecs: 10,
      dismissCountDown: 0,
      newBillingDetailsEmail: '',
      marketingSettings: [],
      accountingCatalogs: [],
      registerCompanyOnly: false
    }
  },
  computed: {
    formCompleted() {
      if (!this.registerCompanyOnly) {
        return this.company.tin &&
          this.company.business_name &&
          this.company.name &&
          this.company.address &&
          this.company.industries &&
          this.company.contact_name &&
          this.company.phone &&
          this.company.email &&
          this.company.billing_details.name &&
          this.company.billing_details.last_name &&
          this.company.billing_details.phone &&
          this.company.billing_details.emails.length > 0 &&
          this.user.name &&
          this.user.email &&
          this.user.password &&
          this.user.password.length >= this.passwordMinLength &&
          this.newPasswordScore >= this.passwordMinScore &&
          this.user.terms
      } else {
        return this.company.tin &&
          this.company.business_name &&
          this.company.name &&
          this.company.address &&
          this.company.industries &&
          this.company.contact_name &&
          this.company.phone &&
          this.company.email &&
          this.company.billing_details.name &&
          this.company.billing_details.last_name &&
          this.company.billing_details.phone &&
          this.company.billing_details.emails.length > 0
      }
    }
  },
  watch: {
    'company.country_iso_code': {
      deep: true,
      handler(val, oldVal) {
        this.fetchAccountingStuff()
      }
    }
  },
  created() {
    this.fetchCountries()
    this.fetchIndustries()
  },
  mounted () {
    if (this.$cookies.get('country')) {
      this.company.country_iso_code = this.$cookies.get('country')
    }
  },
  methods: {
    addBillingDetailsEmail() {
      this.company.billing_details.emails.push(this.newBillingDetailsEmail)
      this.newBillingDetailsEmail = ''
    },
    removeBillingDetailsEmail(index) {
      this.company.billing_details.emails.splice(index, 1)
    },
    createCompany() {
      this.company.industries = [this.company.industries]
      if (!this.registerCompanyOnly) {
        this.$http.post(this.$appConfig.api.baseUrl + 'users/', {
          name: this.user.name,
          email: this.user.email,
          password: this.$refs.pwd_check.password,
          country_iso_code: this.company.country_iso_code,
          terms: this.user.terms
        })
          .then(response => {
            this.user = {...this.user, ...response.body}
            this.$http.post(this.$appConfig.api.baseUrl + 'users/' + this.user.id + '/companies', this.company)
              .then(response => {
                this.$router.push({name: 'viewCompany', params: {id: response.body.id}})
              }, () => {
                this.registerCompanyOnly = true
              })
          }, error => {
            this.sending = false
            let message = ''
            if (error.status === 422) {
              for (let i = 0; i < error.body.errors.length; i++) {
                message += '- ' + error.body.errors[i].detail + '<br>'
              }
            } else if (error.status === 404) {
              message = this.$gettext('Sorry! We still don\'t bring services in your country :(')
            } else {
              message = this.$gettext('The email is already registered<br><br>Please <a href=/login>log in</a> with your previous credentials<br>or<br><a href=/password/reset>click here</a> if you forgot your password') // error.body.message
            }
            let obj = {
              title: this.$gettext('ERROR'),
              message: message,
              type: 'error',
              customCloseBtnText: this.$gettext('Close')
            }
            this.$root.$children[0].$refs.simplert.openSimplert(obj)
          })
      } else {
        this.$http.post(this.$appConfig.api.baseUrl + 'users/' + this.user.id + '/companies', this.company)
          .then(response => {
            this.$router.push({name: 'viewCompany', params: {id: response.body.id}})
          }, () => {
            this.registerCompanyOnly = true
          })
      }
    },
    fetchAccountingStuff() {
      let params = {
        sort: [{
          key: 'name',
          direction: 'asc'
        }],
        filter_groups: [
          {
            filters: [
              ['country_iso_code', 'eq', this.company.country_iso_code],
              ['catalog', 'in', ['customer_types', 'document_types', 'states', 'tax_conditions', 'payment_periods', 'invoicing_programs']]
            ]
          }
        ]
      }
      this.$http.get(this.$appConfig.api.baseUrl + 'accounting-catalogs', {params: params})
        .then(response => {
          this.accountingCatalogs = response.body.data
        })
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }
  }
}
</script>
